export default "__VITE_ASSET__CCTe78vK__"